import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import LoadingIndicator from "Components/LoadingIndicator/LoadingIndicator";

const FormChangePassword = () => {
    const [email, setEmail] = useState();
    const [codeSent, setCodeSent] = useState('');
    const [hasToken, setHasTokenChangePassword] = useState(false);
    const [errorStep, setErrorStep] = useState(false);
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmedPassword, setConfirmedPassword] = useState('');
    const [loadingPanel, setLoadingPanel] = useState(false);

    let navigate = useNavigate();

    useEffect(() => {
        if (errorStep) {
            setTimeout(() => {
                setErrorStep(false)
            }, 5000)
        }
    }, [errorStep])

    const handleSubmit = async (event) => {
        event.preventDefault();
    };

    const routeChange = (path) => {
        navigate(path);
    };

    async function sendRecoverCode() {
        try {
            setErrorStep(false)
            setLoadingPanel(true)
            const parameters = {
                recordedEmail: email
            }
            const response = await ExecuteAxios.api('post', `/send-email/validate-user/`, parameters)

            if (response == 'CREATED') {
                setCodeSent(true)
            } else {
                setErrorStep(true)
            }
        } catch (error) {
            setErrorStep(true)
            console.log(error)
        } finally {
            setLoadingPanel(false)
        }
    }

    async function validateRecoverCode() {
        try {
            setErrorStep(false)
            setLoadingPanel(true)
            const parameters = {
                recordedEmail: email,
                code: code
            }
            const response = await ExecuteAxios.api('post', `/send-email/confirm-email/`, parameters)

            if (response == 'CREATED') {
                setHasTokenChangePassword(true)
            } else {
                setErrorStep(true)
            }
        } catch (error) {
            setErrorStep(true)
            console.log(error)
        } finally {
            setLoadingPanel(false)
        }
    }

    async function changePassword() {
        try {
            setLoadingPanel(true)
            const parameters = {
                password: password,
                confirmedPassword: confirmedPassword,
                recordedEmail: email
            }
            const response = await ExecuteAxios.api('post', `/send-email/change-password/`, parameters)

            if (response == 'CREATED') {
                alert('Senha alterada com sucesso!');
                setEmail(null)
                setPassword(null)
                setConfirmedPassword(null)
                setCode(null)
                setErrorStep(null)
                routeChange('/login')
            } else {
                setPassword('')
                setConfirmedPassword('')
                setErrorStep(true)
            }
        } catch (error) {
            setErrorStep(true)
            console.log(error)
        } finally {
            setLoadingPanel(false)
        }
    }

    const searchYourAccountPanel = () => {
        return (
            <>
                <div id="text-information-password">
                    <h2>Encontre sua conta</h2>
                </div>
                <form className="form" onSubmit={handleSubmit}>
                    <LoadingIndicator loaded={!loadingPanel}>

                        <p>Insira seu email para que seja enviado o código de recuperação da senha.</p>
                        <div className="field">
                            <input
                                className="input-change-password"
                                placeholder="Email"
                                type="email"
                                name="email"
                                id="email"
                                value={email}
                                style={{ width: '300px' }}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div id="response-login" style={{ height: '20px' }}>
                            {errorStep && <span className="form-field-error-password">{"E-mail não encontrado no sistema"}</span>}
                        </div>
                        <div className="actions-change-password" style={{ padding: '40px 0px 20px 10px' }}>
                            <div className="change-password-up">
                                <button onClick={() => sendRecoverCode()} className="button-change-password" type="submit">Enviar</button>
                            </div>
                            <div className="change-password-cancel">
                                <button
                                    className="button-change-password-cancel"
                                    onClick={() => routeChange('/login')}
                                    type="button"
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </LoadingIndicator>
                </form>
            </>
        )
    }

    const insertYourCodePanel = () => {
        return (
            <>
                <div id="text-information-password">
                    <h2>Insira o código de segurança</h2>
                </div>
                <form className="form" onSubmit={handleSubmit}>
                    <p>Enviamos um código de 6 dígitos para seu email no qual você se registrou. Insira o código abaixo.</p>
                    <div className="field">
                        <input
                            className="input-change-password"
                            type="code"
                            name="code"
                            id="code"
                            value={code}
                            style={{ width: '150px' }}
                            onChange={(e) => setCode(e.target.value)}
                        />
                    </div>
                    <div className="actions-change-password" style={{ padding: '60px 0px 20px 10px' }}>
                        <div className="change-password-up">
                            <button onClick={() => validateRecoverCode()} className="button-change-password" type="submit">Confirmar</button>
                        </div>
                        <div className="change-password-cancel">
                            <button
                                className="button-change-password-cancel"
                                onClick={() => routeChange('/login')}
                                type="button"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </form>
            </>
        )
    }

    const changePasswordPanel = () => {
        return (
            <>
                <div id="text-information-password">
                    <h2>Altere sua senha</h2>
                </div>
                <form className="form" onSubmit={handleSubmit}>
                    <p>Crie uma nova senha segura e digite abaixo. Depois, confirme para continuar.</p>
                    <div className="field">
                        <input
                            className="input-change-password"
                            placeholder="Senha"
                            type="password"
                            name="password"
                            id="password"
                            value={password}
                            style={{ width: '200px' }}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div className="field">
                        <input
                            className="input-change-password"
                            placeholder="Confirme a senha"
                            type="password"
                            name="confirmedPassword"
                            id="confirmedPassword"
                            value={confirmedPassword}
                            style={{ width: '200px' }}
                            onChange={(e) => setConfirmedPassword(e.target.value)}
                        />
                    </div>
                    <div className="actions-change-password" style={{ padding: '20px 0px 20px 10px' }}>
                        <div className="change-password-up">
                            <button onClick={() => changePassword()} className="button-change-password" type="submit">Alterar</button>
                        </div>
                        <div className="change-password-cancel">
                            <button
                                className="button-change-password-cancel"
                                onClick={() => routeChange('/login')}
                                type="button"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </form>
            </>
        )
    }

    const getPanelStep = () => {
        if (!codeSent) {
            return (
                <>
                    {searchYourAccountPanel()}
                </>
            )
        } else if (codeSent && !hasToken) {
            return (
                <>
                    {insertYourCodePanel()}
                </>
            )
        } else if (hasToken) {
            return (
                <>
                    {changePasswordPanel()}
                </>
            )
        }

    }

    return (
        <div id="change-password" style={{ height: '100%' }}>
            {getPanelStep()}
        </div>
    );
}

export default FormChangePassword;
